<template>
  <div class="chart-dialog">
    <el-dialog
      title="年级考试柱状图展示"
      :visible.sync="chartShow"
      width="50%"
      :before-close="dialogClose"
    >
      <!-- 柱状图 -->
      <div
        id="myChart"
        ref="chart"
        style="height: 275px; width: 96%; margin: 0 auto"
        v-if="tableData"
      ></div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  props: ["chartShow", "tableData"],
  data() {
    return {
      myChart: null,
      chartBoxShow: false
    };
  },
  watch: {
    chartShow(newVal, oldVal) {
      if (newVal) {
        setTimeout(() => {
          // 初始化柱状图
          this.initChart();
        }, 200);
      }
    },
  },
  beforeDestroy() {
    this.clearChart();
  },
  methods: {
    // 销毁图例
    clearChart() {
      if (
        this.myChart != null &&
        this.myChart != undefined &&
        this.myChart != ""
      ) {
        this.myChart.dispose();
      }
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:chartShow", false);
      this.clearChart();
    },
    initChart() {
      this.myChart = echarts.init(document.getElementById("myChart"));

      let dimensionsList = ["product"];
      let sourceList = [];
      let seriesList = [];

      this.tableData.forEach((item) => {
        dimensionsList.push(item.courseName);
        seriesList.push({
          type: "bar",
        });

        item.descList.forEach((cItem) => {
          const existingItem = sourceList.find(
            (sItem) => sItem.product === cItem.desc
          );

          if (!existingItem) {
            sourceList.push({
              product: cItem.desc,
              [item.courseName]: cItem.descRate,
            });
          } else {
            existingItem[item.courseName] = cItem.descRate;
          }
        });
      });

      // console.log(dimensionsList, sourceList);

      const option = {
        legend: {},
        tooltip: {},
        dataset: {
          dimensions: dimensionsList,
          source: sourceList,
        },
        xAxis: { type: "category" },
        yAxis: {},
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: seriesList,
      };

      // 指定图表的配置项和数据
      this.myChart.setOption(option);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./achievementChartDialog.scss";
</style>